import yup from '@/init/yup';
import { InferType } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export const DoubleLoginSchema = yup.object({
  key_code: yup.string().required('必須です'),
  token: yup.string().required('必須です'),
});
export type DoubleLoginType = InferType<typeof DoubleLoginSchema>;
export const DoubleLoginResolver = yupResolver(DoubleLoginSchema);
